import { IonItem, IonLabel, IonInput } from '@ionic/react'

function InputItem({
  children,
  label,
}: {
  children: React.ReactNode
  label?: string
}) {
  return (
    <IonItem
      style={{
        '--padding-start': 0,
        '--padding-end': 0,
        '--min-height': 44,
        '--inner-padding-end': 0,
      }}
      lines="none"
    >
      {label ? (
        <IonLabel className="mt-0 flex-initial text-base" position="stacked">
          {label}
        </IonLabel>
      ) : null}
      <div className="flex w-full items-center">{children}</div>
    </IonItem>
  )
}

function TextInput({
  label,
  ...props
}: { label?: string } & Omit<
  React.ComponentProps<typeof IonInput>,
  'className'
>) {
  return (
    <InputItem label={label}>
      <IonInput
        style={{
          '--background': 'var(--ion-color-step-100)',
          '--padding-start': '.5rem',
        }}
        className="rounded-md"
        type="text"
        autocapitalize="on"
        {...props}
      />
    </InputItem>
  )
}

function NumericInput({
  label,
  ...props
}: { label?: string } & Omit<
  React.ComponentProps<typeof IonInput>,
  'className'
>) {
  return (
    <InputItem label={label}>
      <IonInput
        style={{
          '--background': 'var(--ion-color-step-100)',
          '--padding-start': '.5rem',
        }}
        className="rounded-md"
        type="number"
        inputMode="numeric"
        {...props}
      />
    </InputItem>
  )
}

export { TextInput, NumericInput }
